<div class="environment-helper">
  <form *ngIf="isDevOrLocal" nz-form>
    <nz-form-control>
      <nz-input-group [nzAddOnBefore]="(isCollapsed$ | async) ? undefined : 'SAP environment'">
        <nz-select [formControl]="sapEnvironmentControl" nzPlaceHolder="SAP environment">
          <nz-option
            *ngFor="let envValue of sapEnvironmentValues; trackBy: trackByRef"
            [nzValue]="envValue"
            [nzLabel]="envValue"
          ></nz-option>
        </nz-select>
      </nz-input-group>
    </nz-form-control>
  </form>
</div>
